import React, { useEffect, useState } from "react";
import UserProfile from "./UserProfile";
import UserDetail from "./UserDetail";
import Language from "../Card/Lang";
import { useLocation } from "react-router-dom";
import { fetchSignedPhotoUrl, produrl, textMapping } from "../utils/helper";

const Home = () => {
  const [profileimage, setProfileimage] = useState("");
  const [freshlang, setFreshlang] = useState("");
  const [editphoto, setEditphoto] = useState("");
  const [editdata, setEditdate] = useState({});
  const location = useLocation();
  const { accesstoken, refreshtoken } = location.state || {};

  const getProfile = (image) => {
    setProfileimage(image);
  };

  const setLanguval = (lang) => {
    setFreshlang(lang);
  };

  useEffect(() => {
    const useredit = localStorage.getItem("useredit");
    if (useredit) {
      getFetchdetail();
    }
  }, []);

  const getFetchdetail = async () => {
    const url = `${produrl}api/v1/pm/details`;
    const options = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("acesss"),
      },
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      if (response.status === 200) {
        setEditdate({
          name: data.data.name || "",
          mobile_number: data.data.phone_number || "",
          date_of_birth: data.data.date_of_birth || "",
          email: data.data.email || "",
          state_id: data.data.state_id || "",
          district: data.data.district_id || "",
          assembly_constituency_id: data.data.assembly_constituency_id || "",
          gender: data.data.gender || "",
          salutation: data.data.salutation || "",
          referred_by_number: data.data.referred_by_number || "",
          pin_code: data.data.pin_code || "",
          address: data.data.address || "",
        });
        setEditphoto(data.data.photo);

        const signedPhotoUrl = await fetchSignedPhotoUrl("profile");
        if (signedPhotoUrl) {
          setEditphoto(signedPhotoUrl);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <section className="home_section">
        {/* <img src="/assets/images/bjpmain.png" className="bjphomemain" alt="" /> */}
        <div className="lang_headerbg">
          <div className="member_container">
            <div className="lang_header">
              <div className="janta_part_flex">
                <img
                  src="/assets/images/bjplogonew.png"
                  className="bjplogo"
                  alt="BJPL Logo"
                />
                <h6>{textMapping("Bharatiya Janata Party")}</h6>
              </div>
              <Language freshlang={setLanguval} />
            </div>
          </div>
        </div>
        <UserProfile getProfile={getProfile} editphoto={editphoto} />
        <UserDetail setProfileimage={profileimage} editdata={editdata} />
      </section>
    </>
  );
};

export default Home;
